(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["bundle-grid"] && !Shopify.designMode) return;
  try {
    
  const SETS_FILTER = '__sets';

  class BundleBox extends HTMLElement {
    connectedCallback() {
      this.texts = JSON.parse(this.querySelector('[data-bundle-texts]').textContent);
      this.root = (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/';
      // "2+1,3+2,6+3" = buy 2 get 1, buy 3 get 2, buy 6 get 3.
      this.steps = this.dataset.steps
        .split(',')
        .map((step) => {
          const [buy, free] = step.split('+').map(Number);
          return { buy, free, total: buy + free };
        })
        .filter((step) => step.total > 0)
        .sort((a, b) => a.total - b.total);
      this.money = new Intl.NumberFormat(document.documentElement.lang || 'es-ES', {
        style: 'currency',
        currency: this.dataset.currency || 'EUR',
      });
      this.sheet = this.querySelector('[data-bundle-sheet]');
      this.form = this.querySelector('[data-bundle-form]');
      this.boxDialog = this.querySelector('[data-bundle-box-dialog]');
      this.quick = this.querySelector('[data-bundle-quick]');
      this.setDialog = this.querySelector('[data-bundle-set-dialog]');
      this.sets = this.readSets();
      this.gridSets = [...this.querySelectorAll('.bundle-box__grid [data-bundle-set]')];
      this.banners = [...this.querySelectorAll('[data-bundle-banner]')];
      this.drawerAt = this.dataset.drawerAt.split(',').map(Number).filter(Boolean);
      this.cards = [...this.querySelectorAll('[data-bundle-card]')];
      this.moreButton = this.querySelector('[data-bundle-more]');
      this.initialCount = Number(this.dataset.initialCount) || 12;
      this.moreCount = Number(this.dataset.moreCount) || 24;
      this.limit = this.initialCount;
      this.filterWord = '';
      this.buildFilters();
      this.renderSetCards();
      if (window.IntersectionObserver) {
        // The next cards load before the customer reaches the button.
        this.moreObserver = new IntersectionObserver(
          (entries) => {
            if (entries.some((entry) => entry.isIntersecting)) this.showMore();
          },
          { rootMargin: '300px' }
        );
        this.moreObserver.observe(this.moreButton);
      }
      this.lines = [];
      this.items = [];
      this.checkoutError = '';

      document.querySelectorAll('a[href="#BundleSets"]').forEach((link) => {
        link.addEventListener('click', (event) => {
          event.preventDefault();
          this.querySelector('#BundleSets').scrollIntoView({ behavior: 'instant', block: 'start' });
        });
      });
      this.addEventListener('click', this.onClick);
      this.addEventListener('pointerdown', this.onPointerDown);
      this.addEventListener('scroll', this.onTrackScroll, true);
      this.form.addEventListener('submit', this.onSubmit);
      this.form.addEventListener('input', this.onFormInput);
      this.form.addEventListener('change', this.onFormChange);
      // Leaving the sheet always ends a set in progress.
      this.sheet.addEventListener('close', () => {
        this.setRun = null;
        this.form.querySelector('[data-bundle-sheet-step]').hidden = true;
      });
      for (const dialog of [this.sheet, this.boxDialog, this.quick, this.setDialog]) {
        dialog.addEventListener('click', (event) => {
          if (event.target === dialog) dialog.close();
        });
      }
      window.addEventListener('pageshow', this.onPageShow);
      this.render();
      this.start();
    }

    disconnectedCallback() {
      this.removeEventListener('click', this.onClick);
      window.removeEventListener('pageshow', this.onPageShow);
      if (this.moreObserver) this.moreObserver.disconnect();
      clearTimeout(this.subscribeTimer);
    }

    // Coming back from the checkout with the back button restores the old page.
    onPageShow = (event) => {
      if (!event.persisted) return;
      this.leaving = false;
      this.refresh();
    };

    async start() {
      // Boxes saved by the old version of this page (before items went straight to the cart).
      const saved = this.loadSaved();
      if (saved.length) {
        try {
          window.localStorage.removeItem(this.dataset.storageKey);
        } catch (error) {}
        try {
          await this.addToCart(saved.map((item) => ({ id: item.variantId, quantity: 1, properties: item.properties || {} })));
        } catch (error) {}
      }
      await this.refresh();
      this.subscribeToDrawer(0);
    }

    loadSaved() {
      try {
        const saved = JSON.parse(window.localStorage.getItem(this.dataset.storageKey) || '[]');
        return Array.isArray(saved) ? saved : [];
      } catch (error) {
        return [];
      }
    }

    // Keep the box in sync when the customer changes the cart inside the UpCart drawer.
    subscribeToDrawer(attempt) {
      if (typeof window.upcartSubscribeCartUpdated === 'function') {
        window.upcartSubscribeCartUpdated(() => {
          if (!this.busy) this.refresh();
        });
        return;
      }
      if (attempt < 20) this.subscribeTimer = setTimeout(() => this.subscribeToDrawer(attempt + 1), 500);
    }

    async refresh() {
      try {
        const response = await fetch(`${this.root}cart.js`, { headers: { Accept: 'application/json' } });
        const cart = await response.json();
        // The deal counts in the whole store, so every cart line counts here too.
        this.lines = cart.items;
        this.originalTotal = cart.original_total_price;
        this.total = cart.total_price;
      } catch (error) {
        return;
      }
      // Gift cards never count for the deal.
      this.items = this.lines
        .filter((line) => !line.gift_card)
        .flatMap((line) =>
          Array.from({ length: line.quantity }, () => ({
            title: line.product_title,
            image: this.imageUrl(line.image, 160),
            productId: line.product_id,
          }))
        );
      this.render();
    }

    // Adds to the real cart without letting UpCart open on its own; we decide when it opens.
    async addToCart(items) {
      const previousSkip = window.upcartShouldSkipAddToCart;
      window.upcartShouldSkipAddToCart = () => true;
      try {
        const response = await fetch(`${this.root}cart/add.js`, {
          method: 'POST',
          headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
          body: JSON.stringify({ items }),
        });
        const data = await response.json();
        if (!response.ok || data.status) {
          throw new Error(data.description || data.message || this.texts.checkoutError);
        }
      } finally {
        window.upcartShouldSkipAddToCart = previousSkip;
      }
    }

    async refreshDrawer() {
      if (typeof window.upcartRefreshCart === 'function') {
        try {
          await window.upcartRefreshCart();
        } catch (error) {}
      }
    }


    format(cents) {
      return this.money.format(cents / 100);
    }

    fill(text, values) {
      return Object.entries(values).reduce((result, [key, value]) => result.replaceAll(`[${key}]`, value), text);
    }

    el(tag, className, text) {
      const node = document.createElement(tag);
      if (className) node.className = className;
      if (text !== undefined) node.textContent = text;
      return node;
    }

    readSets() {
      const sets = {};
      this.querySelectorAll('[data-bundle-set-data]').forEach((script) => {
        const set = JSON.parse(script.textContent);
        // Each piece acts as a product card for the Quick View and the personalise sheet.
        set.items.forEach((item) => {
          item.card = { dataset: { handle: item.handle, perso: item.perso, needsPanel: String(item.needsPanel), variantId: String(item.variantId) } };
        });
        sets[script.dataset.bundleSetData] = set;
      });
      return sets;
    }

    // Free pieces and price always come from the real products, never from typed numbers.
    setInfo(set) {
      const reached = this.steps.filter((step) => set.items.length >= step.total).pop();
      const free = reached ? reached.free : 0;
      const prices = set.items.map((item) => item.price).sort((a, b) => a - b);
      const full = prices.reduce((sum, price) => sum + price, 0);
      const paid = prices.slice(free).reduce((sum, price) => sum + price, 0);
      const available = set.items.length > 0 && set.items.every((item) => item.available && item.perso !== 'page');
      return { free, full, paid, available, size: set.items.length, varies: set.items.some((item) => item.varies) };
    }

    setPrice(node, info) {
      node.replaceChildren();
      if (!info.available) {
        node.textContent = this.texts.setUnavailable;
        return;
      }
      if (info.varies) node.append(`${this.texts.setFrom} `);
      node.append(this.el('s', 'bundle-card__compare', this.format(info.full)));
      node.append(this.format(info.paid));
      const saving = this.fill(this.texts.setSaving, {
        saved: this.format(info.full - info.paid),
        each: this.format(Math.round(info.paid / info.size)),
      });
      node.append(this.el('span', 'bundle-set__saving', saving));
    }

    renderSetCards() {
      this.querySelectorAll('[data-bundle-set]').forEach((card) => {
        const set = this.sets[card.dataset.bundleSet];
        if (!set) return;
        const info = this.setInfo(set);
        card.querySelector('[data-bundle-set-badge]').textContent = this.fill(this.texts.setFree, { free: info.free });
        this.setPrice(card.querySelector('[data-bundle-set-price]'), info);
      });
    }

    // A tap on a set never adds it: this sheet comes first, only the button adds.
    openSet(id) {
      const set = this.sets[id];
      if (!set) return;
      const t = this.texts;
      const info = this.setInfo(set);
      this.currentSet = set;
      const body = this.setDialog.querySelector('[data-bundle-set-body]');
      body.replaceChildren();
      const media = this.el('div', 'bundle-quick__gallery');
      const collage = this.querySelector(`[data-bundle-set="${id}"] .bundle-set__thumbs`);
      if (set.image || !collage) {
        const image = this.el('img');
        image.src = this.imageUrl(set.image || set.items[0].image, 800);
        image.alt = set.name;
        image.style.cssText = 'width:100%;height:100%;object-fit:cover';
        media.append(image);
      } else {
        media.append(collage.cloneNode(true));
      }
      body.append(media, this.el('h2', 'bundle-quick__title', set.name));
      if (set.subtitle) body.append(this.el('p', 'bundle-set__subtitle', set.subtitle));
      const pieces = this.el('div', 'bundle-set-pieces');
      set.items.forEach((item, index) => {
        const piece = this.el('button', 'bundle-set-piece');
        piece.type = 'button';
        piece.dataset.bundleSetPiece = String(index);
        piece.setAttribute('aria-label', item.title);
        const img = this.el('img');
        img.src = this.imageUrl(item.image, 200);
        img.alt = '';
        piece.append(img);
        pieces.append(piece);
      });
      body.append(pieces);
      const price = this.el('p', 'bundle-quick__price');
      this.setPrice(price, info);
      body.append(price);
      const needsChoice = set.items.some((item) => item.needsPanel);
      const add = this.el('button', 'bundle-set-add', needsChoice ? t.setPersonalize : t.setAddAll);
      add.type = 'button';
      add.dataset.bundleSetAdd = '';
      add.disabled = !info.available;
      body.append(add);
      if (needsChoice) body.append(this.el('p', 'bundle-set-help', t.setHelp));
      const keep = this.el('button', 'bundle-quick__link', t.setKeep);
      keep.type = 'button';
      keep.dataset.bundleClose = '';
      body.append(keep);
      this.setDialog.showModal();
      this.setDialog.scrollTop = 0;
    }

    startSet() {
      this.setRun = { set: this.currentSet, index: -1, items: [], values: {}, chosen: [] };
      this.setDialog.close();
      this.stepSet(1);
    }

    // Goes to the next piece that needs a choice; pieces without a choice are collected on the way.
    stepSet(direction) {
      const run = this.setRun;
      const pieces = run.set.items;
      let index = run.index + direction;
      while (index >= 0 && index < pieces.length && !pieces[index].needsPanel) {
        run.items[index] = { id: pieces[index].variantId, quantity: 1, properties: {} };
        index += direction;
      }
      if (index < 0) return;
      if (index >= pieces.length) {
        this.finishSet();
        return;
      }
      run.index = index;
      this.openSheet(pieces[index].card);
    }

    // A choice is made once: the next pieces of the set start with the same name, letter and colour.
    rememberPiece(properties) {
      const run = this.setRun;
      const text = this.form.querySelector('[data-bundle-sheet-fields] input[data-prop]');
      if (text && text.value.trim()) run.values.firstName = text.value.trim();
      Object.assign(run.values, properties);
      const picks = [...this.form.querySelectorAll('[data-option-index]')].map((select) => select.value);
      Object.values(properties).forEach((value) => {
        const letter = String(value).match(/^Inicial - (.)$/);
        if (letter) picks.push(letter[1]);
      });
      picks.filter(Boolean).forEach((value) => {
        run.chosen = run.chosen.filter((item) => item !== value);
        run.chosen.push(value);
      });
    }

    rememberedOption(values) {
      if (!this.setRun) return '';
      // "Oro Rosa de 18K" and "Oro Rosa" are the same colour with a different label per product.
      const clean = (value) => String(value).toLowerCase().replace(/\s*(de\s*)?\d+\s*k\b/g, '').trim();
      for (const chosen of [...this.setRun.chosen].reverse()) {
        const match = values.find((value) => clean(value) === clean(chosen));
        if (match) return match;
      }
      return '';
    }

    rememberedField(spec) {
      if (!this.setRun) return '';
      const { values, chosen } = this.setRun;
      if (values[spec.name]) return spec.max ? values[spec.name].slice(0, spec.max) : values[spec.name];
      if (spec.charm) {
        const letter = [...chosen].reverse().find((value) => /^[A-ZÑ]$/.test(value));
        return letter && spec.name.endsWith(' 1') ? `Inicial - ${letter}` : '';
      }
      return (values.firstName || '').slice(0, spec.max);
    }

    // All pieces go into the cart in one request, then the box opens.
    async finishSet() {
      const items = this.setRun.items.filter(Boolean);
      const submit = this.form.querySelector('[data-bundle-sheet-submit]');
      const sheetError = this.form.querySelector('[data-bundle-sheet-error]');
      submit.disabled = true;
      submit.textContent = this.texts.loading;
      sheetError.hidden = true;
      this.busy = true;
      try {
        await this.addToCart(items);
        this.busy = false;
        await this.refresh();
        if (this.sheet.open) this.sheet.close();
        this.setRun = null;
        await this.refreshDrawer();
        this.openBox();
      } catch (error) {
        this.busy = false;
        sheetError.textContent = error.message || this.texts.checkoutError;
        sheetError.hidden = false;
        this.updateSheetVariant();
      }
    }

    shouldOpenDrawer(before, now) {
      const last = this.drawerAt[this.drawerAt.length - 1] || 0;
      for (let count = before + 1; count <= now; count++) {
        if (this.drawerAt.includes(count) || (count > last && count % 3 === 0)) return true;
      }
      return false;
    }

    cardTitle(card) {
      return card.querySelector('.bundle-card__title').textContent.toLowerCase();
    }

    // "pendiente|arete" matches a title that contains either word.
    titleMatches(card, words) {
      const title = this.cardTitle(card);
      return words.split('|').some((word) => word && title.includes(word));
    }

    // "Pendientes:pendiente|arete" = pill label : words in the product title. Empty pills are left out.
    buildFilters() {
      const box = this.querySelector('[data-bundle-filters]');
      const pills = this.texts.pills
        .split(',')
        .map((pill) => pill.split(':').map((part) => part.trim()))
        .filter(([label, word]) => label && word && this.cards.some((card) => this.titleMatches(card, word.toLowerCase())));
      if (this.gridSets.length || this.querySelector('[data-bundle-set]')) pills.unshift([this.texts.setsPill, SETS_FILTER]);
      if (!pills.length) return;
      [[this.texts.all, ''], ...pills].forEach(([label, word]) => {
        const pill = this.el('button', 'bundle-filter', label);
        pill.type = 'button';
        pill.dataset.bundleFilter = word.toLowerCase();
        pill.setAttribute('aria-pressed', word ? 'false' : 'true');
        box.append(pill);
      });
    }

    // The only place that decides if a card is hidden: filter and limit are checked together.
    updateVisibility() {
      const inBox = new Set(this.items.map((item) => item.productId));
      let shown = 0;
      let left = 0;
      this.cards.forEach((card) => {
        const matches = !this.filterWord || (this.filterWord !== SETS_FILTER && this.titleMatches(card, this.filterWord));
        const fits = matches && shown < this.limit;
        if (fits) shown++;
        else if (matches) left++;
        card.hidden = !fits && !inBox.has(Number(card.dataset.productId));
      });
      // Sets and images stay beside the product card they follow.
      const followsHiddenCard = (element) => {
        let previous = element.previousElementSibling;
        while (previous && !previous.matches('[data-bundle-card]')) previous = previous.previousElementSibling;
        return Boolean(previous && previous.hidden);
      };
      this.gridSets.forEach((set) => {
        set.hidden = this.filterWord !== SETS_FILTER && (Boolean(this.filterWord) || followsHiddenCard(set));
      });
      this.banners.forEach((banner) => {
        banner.hidden = Boolean(this.filterWord) || followsHiddenCard(banner);
      });
      this.moreButton.hidden = left === 0;
      this.moreButton.textContent = this.fill(this.texts.more, { n: left });
    }

    showMore() {
      if (this.moreButton.hidden) return;
      this.limit += this.moreCount;
      this.updateVisibility();
    }

    onPointerDown = (event) => {
      this.pointerX = event.clientX;
    };

    // A swipe on the photos must never count as a tap.
    wasSwipe(event) {
      return this.pointerX !== undefined && Math.abs(event.clientX - this.pointerX) > 10;
    }

    onTrackScroll = (event) => {
      const track = event.target;
      if (!track.dataset || track.dataset.bundleTrack === undefined || !track.clientWidth) return;
      const index = Math.round(track.scrollLeft / track.clientWidth);
      track.parentElement.querySelectorAll('.bundle-card__dot').forEach((dot, i) => dot.classList.toggle('is-active', i === index));
    };

    onClick = (event) => {
      const close = event.target.closest('[data-bundle-close]');
      if (close) {
        close.closest('dialog').close();
        return;
      }
      const filter = event.target.closest('[data-bundle-filter]');
      if (filter) {
        this.filterWord = filter.dataset.bundleFilter;
        this.limit = this.initialCount;
        this.querySelectorAll('[data-bundle-filter]').forEach((pill) => pill.setAttribute('aria-pressed', String(pill === filter)));
        this.updateVisibility();
        return;
      }
      if (event.target.closest('[data-bundle-more]')) {
        this.showMore();
        return;
      }
      const badge = event.target.closest('[data-bundle-card-count]');
      if (badge) {
        this.onBadge(badge);
        return;
      }
      const arrow = event.target.closest('[data-bundle-quick-step]');
      if (arrow) {
        this.stepQuick(Number(arrow.dataset.bundleQuickStep));
        return;
      }
      if (event.target.closest('[data-bundle-quick-add]')) {
        this.addFromQuick(event.target.closest('[data-bundle-quick-add]'));
        return;
      }
      if (event.target.closest('[data-bundle-quick-gallery]')) {
        if (!this.wasSwipe(event)) this.stepQuick(1);
        return;
      }
      const page = event.target.closest('[data-bundle-quick-page]');
      if (page) {
        const { list, index } = this.quickPager;
        const next = (index + Number(page.dataset.bundleQuickPage) + list.length) % list.length;
        this.openQuick(list[next].card, { list, index: next });
        return;
      }
      const piece = event.target.closest('[data-bundle-set-piece]');
      if (piece) {
        const index = Number(piece.dataset.bundleSetPiece);
        this.openQuick(this.currentSet.items[index].card, { list: this.currentSet.items, index });
        return;
      }
      if (event.target.closest('[data-bundle-set-add]')) {
        this.startSet();
        return;
      }
      if (event.target.closest('[data-bundle-sheet-back]')) {
        if (this.setRun) this.stepSet(-1);
        return;
      }
      const setCard = event.target.closest('[data-bundle-set]');
      if (setCard) {
        if (!this.wasSwipe(event)) this.openSet(setCard.dataset.bundleSet);
        return;
      }
      const quickOpen = event.target.closest('[data-bundle-quick-open]');
      if (quickOpen) {
        if (!this.wasSwipe(event)) this.openQuick(quickOpen.closest('[data-bundle-card]'));
        return;
      }
      if (event.target.closest('[data-bundle-box-open]')) {
        this.checkoutError = '';
        this.render();
        this.boxDialog.showModal();
        return;
      }
      const remove = event.target.closest('[data-bundle-remove]');
      if (remove) {
        this.removeOne(remove.dataset.bundleRemove);
        return;
      }
      if (event.target.closest('[data-bundle-checkout]')) {
        this.checkout();
        return;
      }
      if (event.target.closest('[data-bundle-strip]')) {
        this.openBox();
        return;
      }
      const open = event.target.closest('[data-bundle-open]');
      if (open && !open.disabled) {
        const card = open.closest('[data-bundle-card]');
        if (card.dataset.perso === 'page') {
          this.goToProduct(card);
        } else if (card.dataset.needsPanel === 'true') {
          this.openSheet(card);
        } else if (!this.busy) {
          this.flash(open, this.texts.loading);
          this.addItem({ id: Number(card.dataset.variantId) }, {})
            .then(() => this.flash(open, this.texts.added))
            .catch(() => this.flash(open, this.texts.retry));
        }
      }
    };

    onBadge(badge) {
      const productId = Number(badge.closest('[data-bundle-card]').dataset.productId);
      if (badge.dataset.confirm) {
        this.removeProduct(productId);
        return;
      }
      badge.dataset.confirm = 'true';
      badge.textContent = this.texts.removeAll;
      clearTimeout(badge.confirmTimer);
      badge.confirmTimer = setTimeout(() => {
        delete badge.dataset.confirm;
        this.render();
      }, 3000);
    }

    // One request at a time: parallel cart changes give a wrong cart.
    async removeProduct(productId) {
      if (this.busy) return;
      this.busy = true;
      let lines = this.lines;
      try {
        for (let i = 0; i < 20; i++) {
          const line = lines.find((l) => l.product_id === productId);
          if (!line) break;
          const response = await fetch(`${this.root}cart/change.js`, {
            method: 'POST',
            headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
            body: JSON.stringify({ id: line.key, quantity: 0 }),
          });
          lines = (await response.json()).items;
        }
      } catch (error) {}
      this.busy = false;
      await this.refresh();
      await this.refreshDrawer();
    }

    async openQuick(card, pager) {
      const product = await this.productFor(card);
      const t = this.texts;
      this.quickCard = card;
      this.quickPager = pager;
      const body = this.quick.querySelector('[data-bundle-quick-body]');
      body.replaceChildren();

      if (pager) {
        const row = this.el('p', 'bundle-quick__pager');
        [
          [-1, '‹'],
          [1, '›'],
        ].forEach(([step, glyph], i) => {
          const button = this.el('button', '', glyph);
          button.type = 'button';
          button.dataset.bundleQuickPage = String(step);
          row.append(button);
          if (i === 0) row.append(this.el('span', '', `${pager.index + 1} / ${pager.list.length}`));
        });
        body.append(row);
      }

      const gallery = this.el('div', 'bundle-quick__gallery');
      gallery.dataset.bundleQuickGallery = '';
      const track = this.el('div', 'bundle-quick__track');
      product.images.forEach((src) => {
        const img = this.el('img');
        img.src = this.imageUrl(src, 800);
        img.alt = product.title;
        img.loading = 'lazy';
        track.append(img);
      });
      gallery.append(track);
      this.quickTrack = track;
      body.append(gallery);

      if (t.rating) {
        const rating = this.el('p', 'bundle-rating');
        const stars = this.el('span', '', '★★★★★');
        stars.setAttribute('aria-hidden', 'true');
        rating.append(stars, ` ${t.rating}`);
        body.append(rating);
      }
      body.append(this.el('h2', 'bundle-quick__title', product.title));

      const variant = product.variants.find((v) => v.available) || product.variants[0];
      const price = this.el('p', 'bundle-quick__price');
      if (variant.compare_at_price > variant.price) {
        price.append(this.el('s', 'bundle-card__compare', this.format(variant.compare_at_price)));
      }
      price.append(this.format(variant.price));
      body.append(price);

      const add = this.el('button', 'bundle-quick__add');
      add.type = 'button';
      add.dataset.bundleQuickAdd = '';
      add.disabled = !product.available;
      add.append(this.el('span', '', this.quickAddLabel(card, product)));
      add.firstChild.dataset.bundleAddText = '';
      if (!pager) body.append(add);

      const description = this.el('div', 'bundle-quick__description');
      description.innerHTML = product.description || '';
      body.append(description);

      const benefits = this.el('ul', 'bundle-quick__benefits');
      t.benefits
        .split(',')
        .map((text) => text.trim())
        .filter(Boolean)
        .forEach((text) => benefits.append(this.el('li', '', text)));
      body.append(benefits);

      const link = this.el('a', 'bundle-quick__link', t.fullProduct);
      link.href = `${this.root}products/${product.handle}`;
      body.append(link);

      if (product.images.length > 1) {
        [
          [-1, '‹', 'prev'],
          [1, '›', 'next'],
        ].forEach(([step, glyph, side]) => {
          const arrow = this.el('button', `bundle-quick__arrow bundle-quick__arrow--${side}`, glyph);
          arrow.type = 'button';
          arrow.dataset.bundleQuickStep = String(step);
          arrow.setAttribute('aria-label', side);
          gallery.append(arrow);
        });
      }
      if (!this.quick.open) this.quick.showModal();
      this.quick.scrollTop = 0;
    }

    quickAddLabel(card, product) {
      if (!product.available) return this.texts.soldOut;
      return card.dataset.perso === 'none' ? this.texts.add : this.texts.personalize;
    }

    stepQuick(step) {
      const track = this.quickTrack;
      const count = track.children.length;
      if (count < 2) return;
      const index = Math.round(track.scrollLeft / track.clientWidth);
      track.scrollLeft = ((index + step + count) % count) * track.clientWidth;
    }

    // These products are personalised on their own product page, never added blind.
    goToProduct(card) {
      window.location.href = `${this.root}products/${card.dataset.handle}`;
    }

    addFromQuick(button) {
      const card = this.quickCard;
      if (card.dataset.perso === 'page') {
        this.goToProduct(card);
        return;
      }
      if (card.dataset.needsPanel === 'true') {
        this.quick.close();
        this.openSheet(card);
        return;
      }
      if (this.busy) return;
      this.flash(button, this.texts.loading);
      this.addItem({ id: Number(card.dataset.variantId) }, {}, () => this.quick.close())
        .then(() => this.flash(card.querySelector('[data-bundle-open]'), this.texts.added))
        .catch(() => this.flash(button, this.texts.retry));
    }

    // Product details load only when a customer opens a product, which keeps the page light.
    async productFor(card) {
      if (!card.bundleProduct) {
        const response = await fetch(`${this.root}products/${card.dataset.handle}.js`, { headers: { Accept: 'application/json' } });
        const product = await response.json();
        product.options = product.options.map((option) => option.name || option);
        card.bundleProduct = product;
      }
      return card.bundleProduct;
    }

    imageUrl(src, width) {
      if (!src) return '';
      const url = src.startsWith('//') ? `https:${src}` : src;
      return `${url}${url.includes('?') ? '&' : '?'}width=${width}`;
    }

    async openSheet(card) {
      const product = await this.productFor(card);
      this.current = { card, product, perso: card.dataset.perso };
      this.form.querySelector('[data-bundle-sheet-title]').textContent = product.title;
      const optionsBox = this.form.querySelector('[data-bundle-sheet-options]');
      optionsBox.replaceChildren();
      this.form.querySelector('[data-bundle-sheet-fields]').replaceChildren();
      const stepRow = this.form.querySelector('[data-bundle-sheet-step]');
      stepRow.hidden = !this.setRun;
      if (this.setRun) {
        this.form.querySelector('[data-bundle-sheet-step-text]').textContent = this.fill(this.texts.setStep, {
          n: this.setRun.index + 1,
          total: this.setRun.set.items.length,
        });
        this.form.querySelector('[data-bundle-sheet-back]').hidden = this.setRun.index === 0;
      }

      product.options.forEach((name, index) => {
        const values = [...new Set(product.variants.map((v) => v.options[index]))];
        if (values.length < 2) return;
        const field = this.el('div', 'bundle-field');
        const id = `BundleOpt-${product.id}-${index}`;
        const label = this.el('label', 'bundle-field__label', name);
        label.htmlFor = id;
        const select = this.el('select', 'bundle-field__input');
        select.id = id;
        select.dataset.optionIndex = String(index);
        // Nothing is preselected: the customer makes every choice.
        const blank = this.el('option', '', this.texts.choose);
        blank.value = '';
        select.append(blank);
        values.forEach((value) => {
          const option = this.el('option', '', value);
          option.value = value;
          select.append(option);
        });
        const remembered = this.rememberedOption(values);
        if (remembered) select.value = remembered;
        field.append(label, select);
        optionsBox.append(field);
      });

      this.renderFields();
      this.updateSheetVariant();
      this.form.querySelector('[data-bundle-sheet-error]').hidden = true;
      if (!this.sheet.open) this.sheet.showModal();
      this.sheet.scrollTop = 0;
    }

    selectedVariant() {
      const { product } = this.current;
      const chosen = product.options.map((_, index) => {
        const select = this.form.querySelector(`[data-option-index="${index}"]`);
        return select ? select.value : null;
      });
      return product.variants.find((v) => v.options.every((value, i) => chosen[i] === null || chosen[i] === value));
    }

    fieldCount() {
      const { product } = this.current;
      const variant = this.selectedVariant() || product.variants[0];
      const countWords = /nombre|n[uú]mero|coraz|charm|modelo/i;
      for (let i = 0; i < product.options.length; i++) {
        const values = [...new Set(product.variants.map((v) => v.options[i]))];
        if (!countWords.test(product.options[i]) && !values.every((v) => /nombre/i.test(v))) continue;
        if (!values.every((v) => /\d/.test(v))) continue;
        const match = String(variant.options[i]).match(/\d+/);
        if (match) return Math.max(1, Math.min(8, parseInt(match[0], 10)));
      }
      return 1;
    }

    fieldSpecs() {
      const t = this.texts;
      const count = this.fieldCount();
      switch (this.current.perso) {
        case 'names':
          return Array.from({ length: count }, (_, i) => ({
            name: `${t.personalization} ${i + 1}`,
            required: true,
            max: 10,
          }));
        case 'two_names':
          return [
            { name: `${t.personalization} 1`, required: true, max: 12 },
            { name: `${t.personalization} 2`, required: false, max: 12 },
          ];
        case 'egy':
          return [{ name: t.name, required: true, max: 10, clean: /[^a-zA-Z0-9À-ÿ .,/]/g }];
        case 'charms':
          return Array.from({ length: count }, (_, i) => ({ name: `${t.option} ${i + 1}`, required: true, charm: true }));
        default:
          return [];
      }
    }

    charmGroups() {
      const t = this.texts.charmGroups;
      if (this.charmCatalog) return this.charmCatalog;
      const stones = [
        ['Enero (Granate Rojo)', '#8B1E2B'],
        ['Febrero (Amatista Violeta)', '#8E5FA6'],
        ['Marzo (Aguamarina Azul)', '#6FA8DC'],
        ['Abril (Cristal Claro)', '#D9D9D9'],
        ['Mayo (Esmeralda Verde)', '#2E8B57'],
        ['Junio (Alejandrita Púrpura)', '#6A1B4D'],
        ['Julio (Rubí Rosado)', '#D6336C'],
        ['Agosto (Peridoto Verde)', '#9ACD32'],
        ['Septiembre (Zafiro Azul)', '#1B3F8B'],
        ['Octubre (Turmalina Rosa)', '#E8A0BF'],
        ['Noviembre (Citrino Amarillo)', '#F4D35E'],
        ['Diciembre (Topacio Azul)', '#3FA9F5'],
      ];
      const signs = [
        ['Aries (21 mar - 19 abr)', '♈'],
        ['Tauro (20 abr - 20 may)', '♉'],
        ['Géminis (21 may - 20 jun)', '♊'],
        ['Cáncer (21 jun - 22 jul)', '♋'],
        ['Leo (23 jul - 22 ago)', '♌'],
        ['Virgo (23 ago - 22 sep)', '♍'],
        ['Libra (23 sep - 22 oct)', '♎'],
        ['Escorpio (23 oct - 21 nov)', '♏'],
        ['Sagitario (22 nov - 21 dic)', '♐'],
        ['Capricornio (22 dic - 19 ene)', '♑'],
        ['Acuario (20 ene - 18 feb)', '♒'],
        ['Piscis (19 feb - 20 mar)', '♓'],
      ];
      this.charmCatalog = [
        [
          t[0],
          [
            { label: 'Corazón Rojo', cat: 'heart', color: '#e0455f', glyph: '♥' },
            { label: 'Corazón Rosa', cat: 'heart', color: '#f4a6c1', glyph: '♥' },
          ],
        ],
        [t[1], stones.map(([name, color]) => ({ label: `Piedra - ${name}`, cat: 'stone', color, glyph: '' }))],
        [t[2], signs.map(([name, glyph]) => ({ label: `Zodiaco - ${name}`, cat: 'zodiac', glyph: `${glyph}︎` }))],
        [
          t[3],
          'ABCDEFGHIJKLMNOPQRSTUVWXYZ'.split('').map((l) => ({ label: `Inicial - ${l}`, cat: 'initial', glyph: l })),
        ],
      ];
      return this.charmCatalog;
    }

    renderCharmPreview() {
      const preview = this.form.querySelector('[data-bundle-charm-preview]');
      if (!preview) return;
      const lookup = new Map();
      this.charmGroups().forEach(([, items]) => items.forEach((item) => lookup.set(item.label, item)));
      preview.replaceChildren();
      this.form.querySelectorAll('[data-bundle-sheet-fields] select[data-prop]').forEach((select) => {
        const item = lookup.get(select.value);
        if (!item) return;
        const charm = this.el('span', 'bundle-charm', item.glyph);
        charm.dataset.cat = item.cat;
        charm.title = item.label;
        if (item.cat === 'heart') charm.style.color = item.color;
        if (item.cat === 'stone') charm.style.background = item.color;
        preview.append(charm);
      });
    }

    renderFields() {
      const box = this.form.querySelector('[data-bundle-sheet-fields]');
      const previous = {};
      box.querySelectorAll('[data-prop]').forEach((input) => {
        previous[input.dataset.prop] = input.value;
      });
      box.replaceChildren();
      const { product } = this.current;

      this.fieldSpecs().forEach((spec, index) => {
        const id = `BundleField-${product.id}-${index}`;
        const field = this.el('div', 'bundle-field');
        const label = this.el('label', 'bundle-field__label', spec.name);
        label.htmlFor = id;
        if (!spec.required) label.append(' ', this.el('span', 'bundle-field__optional', this.texts.optional));
        const wrap = this.el('div', 'bundle-field__wrap');
        let input;

        if (spec.charm) {
          input = this.el('select', 'bundle-field__input');
          const blank = this.el('option', '', this.texts.choose);
          blank.value = '';
          input.append(blank);
          this.charmGroups().forEach(([group, items]) => {
            const optgroup = document.createElement('optgroup');
            optgroup.label = group;
            items.forEach((item) => {
              const option = this.el('option', '', item.label);
              option.value = item.label;
              optgroup.append(option);
            });
            input.append(optgroup);
          });
        } else {
          input = this.el('input', 'bundle-field__input');
          input.type = 'text';
          input.maxLength = spec.max;
          input.autocomplete = 'off';
          if (spec.clean) input.dataset.clean = spec.clean.source;
        }

        input.id = id;
        input.dataset.prop = spec.name;
        input.required = spec.required;
        input.value = previous[spec.name] || this.rememberedField(spec);
        wrap.append(input);

        if (spec.max) {
          const counter = this.el('span', 'bundle-field__counter', `${input.value.length}/${spec.max}`);
          counter.dataset.counter = '';
          wrap.append(counter);
        }

        const error = this.el('p', 'bundle-field__error', this.texts.required);
        error.id = `${id}-error`;
        error.hidden = true;
        field.append(label, wrap, error);
        box.append(field);
      });

      if (this.current.perso === 'charms') {
        const previewField = this.el('div', 'bundle-field bundle-charms');
        previewField.append(this.el('p', 'bundle-field__label', this.texts.preview));
        const preview = this.el('div', 'bundle-charms__preview');
        preview.dataset.bundleCharmPreview = '';
        previewField.append(preview);
        box.append(previewField);
      }
      this.refreshCharmChoices();
    }

    refreshCharmChoices() {
      const selects = [...this.form.querySelectorAll('[data-bundle-sheet-fields] select[data-prop]')];
      const used = selects.map((s) => s.value).filter(Boolean);
      selects.forEach((select) => {
        select.querySelectorAll('option').forEach((option) => {
          option.disabled = option.value !== '' && option.value !== select.value && used.includes(option.value);
        });
      });
      this.renderCharmPreview();
    }

    updateSheetVariant() {
      const variant = this.selectedVariant();
      const { product } = this.current;
      const submit = this.form.querySelector('[data-bundle-sheet-submit]');
      const image = this.form.querySelector('[data-bundle-sheet-image]');
      const src = (variant && variant.featured_image && variant.featured_image.src) || product.featured_image;
      image.src = this.imageUrl(src, 200);
      image.alt = product.title;
      if (variant && variant.featured_image) {
        const { card } = this.current;
        const cardImage = card.querySelector && card.querySelector('[data-bundle-track] img');
        if (cardImage) {
          cardImage.removeAttribute('srcset');
          cardImage.src = this.imageUrl(variant.featured_image.src, 600);
        }
      }
      this.form.querySelector('[data-bundle-sheet-price]').textContent = this.format(variant ? variant.price : product.price);
      const complete = this.sheetComplete();
      const available = Boolean(variant && variant.available);
      submit.disabled = !complete || !available;
      if (!complete) submit.textContent = this.texts.complete;
      else if (!available) submit.textContent = this.texts.soldOut;
      else submit.textContent = this.sheetAddLabel();
    }

    sheetAddLabel() {
      if (!this.setRun) return this.texts.add;
      const later = this.setRun.set.items.slice(this.setRun.index + 1);
      return later.some((item) => item.needsPanel) ? this.texts.setNext : this.texts.setAddAll;
    }

    // Add stays blocked until every option is chosen and every required field is filled in.
    sheetComplete() {
      const options = [...this.form.querySelectorAll('[data-option-index]')];
      const fields = [...this.form.querySelectorAll('[data-bundle-sheet-fields] [data-prop]')];
      return options.every((select) => select.value) && fields.every((input) => !input.required || input.value.trim());
    }

    onFormInput = (event) => {
      const input = event.target;
      if (!input.dataset || !input.dataset.prop || input.tagName !== 'INPUT') return;
      if (input.dataset.clean) {
        const cleaned = input.value.replace(new RegExp(input.dataset.clean, 'g'), '');
        if (cleaned !== input.value) input.value = cleaned;
      }
      const counter = input.parentElement.querySelector('[data-counter]');
      if (counter) counter.textContent = `${input.value.length}/${input.maxLength}`;
      if (input.value.trim()) this.setFieldError(input, false);
      this.updateSheetVariant();
    };

    onFormChange = (event) => {
      const target = event.target;
      if (target.dataset.optionIndex !== undefined) {
        this.renderFields();
        this.updateSheetVariant();
        return;
      }
      if (target.dataset.prop) {
        if (target.value) this.setFieldError(target, false);
        this.refreshCharmChoices();
        this.updateSheetVariant();
      }
    };

    setFieldError(input, show, message) {
      const error = this.form.querySelector(`#${input.id}-error`);
      input.setAttribute('aria-invalid', show ? 'true' : 'false');
      if (show) input.setAttribute('aria-describedby', `${input.id}-error`);
      else input.removeAttribute('aria-describedby');
      if (error) {
        error.hidden = !show;
        if (message) error.textContent = message;
      }
    }

    onSubmit = async (event) => {
      event.preventDefault();
      const variant = this.selectedVariant();
      if (!variant || !variant.available || this.busy) return;
      const properties = {};
      let firstInvalid = null;

      this.form.querySelectorAll('[data-bundle-sheet-fields] [data-prop]').forEach((input) => {
        const value = input.value.trim();
        if (input.required && !value) {
          this.setFieldError(input, true, this.texts.required);
          firstInvalid = firstInvalid || input;
          return;
        }
        this.setFieldError(input, false);
        if (value) properties[input.dataset.prop] = value;
      });

      if (firstInvalid) {
        firstInvalid.focus();
        return;
      }

      if (this.setRun) {
        this.setRun.items[this.setRun.index] = { id: variant.id, quantity: 1, properties };
        this.rememberPiece(properties);
        this.stepSet(1);
        return;
      }

      const submit = this.form.querySelector('[data-bundle-sheet-submit]');
      const sheetError = this.form.querySelector('[data-bundle-sheet-error]');
      submit.disabled = true;
      submit.textContent = this.texts.loading;
      sheetError.hidden = true;
      try {
        // The sheet must be closed before the drawer opens, or it would sit on top of it.
        await this.addItem(variant, properties, () => this.sheet.close());
        this.flash(this.current.card.querySelector('[data-bundle-open]'), this.texts.added);
      } catch (error) {
        sheetError.textContent = error.message || this.texts.checkoutError;
        sheetError.hidden = false;
      } finally {
        this.updateSheetVariant();
      }
    };

    async addItem(variant, properties, beforeOpen) {
      this.busy = true;
      const before = this.items.length;
      try {
        await this.addToCart([{ id: variant.id, quantity: 1, properties }]);
      } finally {
        this.busy = false;
      }
      this.checkoutError = '';
      await this.refresh();
      if (beforeOpen) beforeOpen();
      const bar = this.querySelector('[data-bundle-bar]');
      bar.classList.remove('bundle-bar--pulse');
      void bar.offsetWidth;
      bar.classList.add('bundle-bar--pulse');

      await this.refreshDrawer();
      if (this.shouldOpenDrawer(before, this.items.length)) this.openBox();
    }

    stepsReached(count) {
      return this.steps.filter((step) => count >= step.total).length;
    }

    // On mobile the box is a popup; on desktop it is already visible in the sidebar.
    openBox() {
      const side = this.querySelector('.bundle-layout__side');
      if (side && side.offsetParent !== null) {
        side.scrollTop = 0;
        return;
      }
      if (!this.boxDialog.open) this.boxDialog.showModal();
      this.boxDialog.scrollTop = 0;
    }

    async removeOne(key) {
      const line = this.lines.find((l) => l.key === key);
      if (!line || this.busy) return;
      this.busy = true;
      try {
        await fetch(`${this.root}cart/change.js`, {
          method: 'POST',
          headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
          body: JSON.stringify({ id: key, quantity: line.quantity - 1 }),
        });
      } catch (error) {}
      this.busy = false;
      await this.refresh();
      await this.refreshDrawer();
    }

    flash(button, message) {
      const label = button && button.querySelector('[data-bundle-add-text]');
      if (!label) return;
      if (!button.dataset.label) button.dataset.label = label.textContent;
      label.textContent = message;
      clearTimeout(button.flashTimer);
      button.flashTimer = setTimeout(() => {
        label.textContent = button.dataset.label;
      }, 1500);
    }

    summary() {
      const count = this.items.length;
      const reached = this.stepsReached(count);
      const nextStep = this.steps[reached];
      const firstStep = this.steps[0];
      const needed = nextStep ? nextStep.total - count : 0;
      // Real cart numbers: Shopify already applies the automatic discount to the cart.
      const subtotal = this.originalTotal || 0;
      const total = this.total || 0;
      const savings = subtotal - total;
      const free = this.lines.reduce(
        (sum, line) => sum + Math.round((line.original_line_price - line.final_line_price) / (line.original_price || 1)),
        0
      );
      // The bar stays full and green from the first free piece: no push right after a reward.
      const progress = reached ? 100 : Math.round((count / firstStep.total) * 100);
      const values = { count, free, needed, nextfree: nextStep ? nextStep.free : 0, amount: this.format(savings) };
      let status = this.texts.status;
      let next = this.texts.next;
      let tone = '';
      if (count === 0) {
        status = this.texts.empty;
        next = '';
      } else if (reached === 1) {
        status = this.texts.statusFree;
        next = this.texts.hint;
        tone = 'hint';
      } else if (reached > 1) {
        status = this.texts.statusFree;
        next = this.texts.saved;
        tone = 'saved';
      }
      return {
        count,
        free,
        subtotal,
        total,
        savings,
        progress,
        done: reached > 0,
        tone,
        status: this.fill(status, values),
        next: this.fill(next, values),
      };
    }

    renderBar(s) {
      const bar = this.querySelector('[data-bundle-bar]');
      bar.classList.toggle('bundle-bar--done', s.done);
      const text = bar.querySelector('.bundle-bar__text');
      text.classList.toggle('bundle-bar__text--hint', s.tone === 'hint');
      text.classList.toggle('bundle-bar__text--saved', s.tone === 'saved');
      bar.querySelector('[data-bundle-actions]').hidden = s.count === 0;

      const strip = bar.querySelector('[data-bundle-strip]');
      strip.replaceChildren();
      this.items.slice(0, 4).forEach((item) => {
        const img = this.el('img');
        img.src = item.image;
        img.alt = '';
        img.width = 36;
        img.height = 36;
        strip.append(img);
      });
      if (s.count > 4) strip.append(this.el('span', '', `+${s.count - 4}`));

      const checkout = bar.querySelector('[data-bundle-checkout]');
      checkout.textContent = this.leaving ? this.texts.loading : this.fill(this.texts.barCheckout, { total: this.format(s.total) });
      checkout.disabled = this.leaving === true;
    }

    render() {
      const s = this.summary();
      this.querySelector('[data-bundle-status]').textContent = s.status;
      this.querySelector('[data-bundle-next]').textContent = s.next;
      this.querySelector('[data-bundle-fill]').style.width = `${s.progress}%`;
      this.renderBar(s);
      this.updateVisibility();
      const openButton = this.querySelector('[data-bundle-box-open]');
      if (!openButton.dataset.label) openButton.dataset.label = openButton.textContent;
      openButton.textContent = `${openButton.dataset.label} (${s.count})`;

      const perProduct = new Map();
      this.items.forEach((item) => perProduct.set(item.productId, (perProduct.get(item.productId) || 0) + 1));
      this.querySelectorAll('[data-bundle-card]').forEach((card) => {
        const badge = card.querySelector('[data-bundle-card-count]');
        const quantity = perProduct.get(Number(card.dataset.productId)) || 0;
        badge.hidden = quantity === 0;
        if (quantity === 0) delete badge.dataset.confirm;
        if (!badge.dataset.confirm) badge.textContent = quantity > 1 ? `${this.texts.badge} ×${quantity}` : this.texts.badge;
      });

      this.querySelectorAll('[data-bundle-view]').forEach((view) => this.renderPanel(view, s));
    }

    renderPanel(view, s) {
      const t = this.texts;
      view.replaceChildren();
      view.classList.toggle('bundle-panel--done', s.done);
      view.append(this.el('h2', 'bundle-panel__title', t.boxTitle));
      view.append(this.el('p', 'bundle-panel__status', s.status));
      view.append(this.el('p', 'bundle-panel__next', s.next));

      const track = this.el('div', 'bundle-panel__track');
      const fill = this.el('span', 'bundle-panel__fill');
      fill.style.width = `${s.progress}%`;
      track.append(fill);
      view.append(track);

      const tiers = this.el('ol', 'bundle-panel__tiers');
      this.steps.forEach((step) => {
        const done = s.count >= step.total;
        const label = this.fill(t.tier, { buy: step.buy, free: step.free });
        tiers.append(this.el('li', `bundle-tier${done ? ' bundle-tier--done' : ''}`, done ? `✓ ${label}` : label));
      });
      view.append(tiers);

      const slots = this.el('ol', 'bundle-panel__slots');
      const lastStep = this.steps[this.steps.length - 1];
      const slotCount = Math.max(lastStep ? lastStep.total : 0, s.count);
      for (let i = 1; i <= slotCount; i++) {
        const isFreeSlot = this.steps.some((step) => step.total === i);
        const item = this.items[i - 1];
        const slot = this.el('li', `bundle-slot${isFreeSlot ? ' bundle-slot--free' : ''}${item ? ' bundle-slot--filled' : ''}`);
        if (item) {
          const img = this.el('img');
          img.src = item.image;
          img.alt = item.title;
          img.loading = 'lazy';
          slot.append(img);
          if (isFreeSlot) slot.append(this.el('span', 'bundle-slot__tag', t.free));
        } else {
          slot.textContent = isFreeSlot ? t.free : String(i);
        }
        slots.append(slot);
      }
      view.append(slots);

      if (this.lines.length) {
        const list = this.el('ul', 'bundle-panel__items');
        this.lines.forEach((line) => {
          const row = this.el('li', 'bundle-item');
          const img = this.el('img');
          img.src = this.imageUrl(line.image, 160);
          img.alt = '';
          img.loading = 'lazy';
          const info = this.el('div');
          info.append(this.el('p', 'bundle-item__title', line.quantity > 1 ? `${line.product_title} ×${line.quantity}` : line.product_title));
          const properties = Object.entries(line.properties || {}).filter(([k, v]) => v && !k.startsWith('_'));
          const variantTitle = line.product_has_only_default_variant ? '' : line.variant_title;
          const meta = [variantTitle, ...properties.map(([k, v]) => `${k}: ${v}`)].filter(Boolean);
          meta.forEach((text) => info.append(this.el('p', 'bundle-item__meta', text)));
          const side = this.el('div', 'bundle-item__side');
          side.append(this.el('span', '', this.format(line.final_line_price)));
          const remove = this.el('button', 'bundle-item__remove', t.remove);
          remove.type = 'button';
          remove.dataset.bundleRemove = line.key;
          remove.setAttribute('aria-label', `${t.remove}: ${line.product_title}`);
          side.append(remove);
          row.append(img, info, side);
          list.append(row);
        });
        view.append(list);
      }

      // Totals and the checkout button stay pinned to the bottom of the box, so no scrolling is needed.
      const footer = this.el('div', 'bundle-panel__footer');
      if (this.lines.length) {
        const totals = this.el('dl', 'bundle-panel__totals');
        totals.append(this.el('dt', '', t.subtotal), this.el('dd', '', this.format(s.subtotal)));
        if (s.savings > 0) {
          totals.append(
            this.el('dt', 'bundle-panel__savings', t.savings),
            this.el('dd', 'bundle-panel__savings', `−${this.format(s.savings)}`)
          );
        }
        totals.append(
          this.el('dt', 'bundle-panel__total', t.total),
          this.el('dd', 'bundle-panel__total', this.format(s.total))
        );
        footer.append(totals);
      }

      const checkout = this.el('button', 'bundle-panel__checkout', this.leaving ? t.loading : t.checkout);
      checkout.type = 'button';
      checkout.dataset.bundleCheckout = '';
      checkout.disabled = this.items.length === 0 || this.leaving === true;
      footer.append(checkout);
      if (this.checkoutError) footer.append(this.el('p', 'bundle-panel__error', this.checkoutError));
      const payments = this.querySelector('[data-bundle-payments]');
      if (payments) footer.append(payments.content.cloneNode(true));
      if (t.boxNote) footer.append(this.el('p', 'bundle-panel__note', t.boxNote));
      if (t.note) footer.append(this.el('p', 'bundle-panel__note', t.note));
      view.append(footer);
    }

    // Everything is already in the cart, so the box button goes straight to checkout.
    checkout() {
      if (!this.items.length || this.leaving) return;
      this.leaving = true;
      this.render();
      window.location.href = `${this.root}checkout`;
    }
  }

  if (!customElements.get('bundle-box')) customElements.define('bundle-box', BundleBox);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();
})();
